export default __webpack_public_path__ + "static/media/Group 3405.1da1d471.png";